import { render, staticRenderFns } from "./HouseholdPage.vue?vue&type=template&id=0ab30a50&scoped=true&"
import script from "./HouseholdPage.vue?vue&type=script&lang=ts&"
export * from "./HouseholdPage.vue?vue&type=script&lang=ts&"
import style0 from "./HouseholdPage.vue?vue&type=style&index=0&id=0ab30a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab30a50",
  null
  
)

export default component.exports